import React, { useState, useEffect } from "react";
import {
  Grid,
  Divider,
  Button,
  Header,
  Modal,
  Icon,
  Form,
} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import { decryptData, secretKey } from "../store/Encrypt";
import Cookies from "js-cookie";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { renderTextField } from "../formcomponents";
import { reduxForm, Field } from "redux-form";
import { userData } from "../store/userData";
const DailyWorkList = ({ categoryId }) => {
  const navigate = useNavigate();

  // getDailyWorkDetails
  // dailyWorkId=?   --> for Details

  //listDailyWorkForAdmin --> for admin list
  const userDetail = userData();
  //listDailyWork  ,userId=? -->for particuler user
  const [excelData, setexcelData] = useState([]);
  const [grandTotal, setgrandTotal] = useState(0);
  const [grandTotalAmount, setgrandTotalAmount] = useState(0);
  const [rowData, setrowData] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  useEffect(() => {
    const authTokens = Cookies.get("authTokens");

    const decryptedJSON = decryptData(authTokens, secretKey);

    if (categoryId === 0) {
      getWorkList("/accounts/listDailyWorkForAdmin", decryptedJSON.userId);
    } else {
      if (decryptedJSON.userRole === 1) {
        getWorkList("/accounts/listDailyWork", decryptedJSON.userId);
      } else {
        getWorkList("/accounts/listDailyWork", decryptedJSON.userId);
      }
    }
  }, []);
  useEffect(() => {
    // Calculate grand total when rowData changes
    if (rowData) {
      let total = 0,
        tatalAmount = 0;
      for (let i = 0; i < rowData.length; i++) {
        total += parseFloat(rowData[i].totalBalance) || 0;
      }
      for (let i = 0; i < rowData.length; i++) {
        tatalAmount += parseFloat(rowData[i].amount) || 0;
      }
      setgrandTotalAmount(tatalAmount);
      setgrandTotal(total);
    }
  }, [rowData]);
  const getWorkList = (url, id) => {
    console.log(url);

    const postObject = {
      getAll: categoryId === 0 ? true : false,
      dateFilter: fromDate != "" && toDate != "" ? true : false,
      startDate: fromDate,
      endDate: toDate,
      workCategory: categoryId,
    };

    console.log(JSON.stringify(postObject, null, 2));
    axios
      .post(BaseUrlInvoice + "accounts/listDailyWork", postObject)
      .then((res) => {
        console.log(res.data);

        setRecordForTable(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setRecordForTable = (record) => {
    let tempRecord = [];
    let grandTotal = 0;
    for (let i = 0; i < record.length; i++) {
      let workDate = record[i].workDate,
        forWork = record[i].forWork,
        forWorkType = record[i].forWorkType,
        toOrBy = record[i].toOrBy,
        totalAmount = record[i].totalAmount,
        dailyWorkId = record[i].dailyWorkId;

      if (record[i].workDetailsList) {
        for (let j = 0; j < record[i].workDetailsList.length; j++) {
          tempRecord.push({
            dailyWorkId: dailyWorkId,
            workDate: workDate
              ? new Date(workDate).toLocaleDateString("en-GB")
              : "",
            forWork: forWork,
            forWorkType: forWorkType,
            toOrBy: toOrBy,
            item: record[i].workDetailsList[j].item,
            amount: record[i].workDetailsList[j].amount,
            category: record[i].workDetailsList[j].category,
            description: record[i].workDetailsList[j].description,
            quantity: record[i].workDetailsList[j].quantity,
            unitPrice: record[i].workDetailsList[j].unitPrice,
            discount: record[i].workDetailsList[j].discount,
            discountPer: record[i].workDetailsList[j].discountPer,
            totalBalance: record[i].workDetailsList[j].totalBalance,
            remarks: record[i].workDetailsList[j].remarks,
          });
        }
      }
    }
    let tempRecForExcel = [];
    for (let i = 0; i < record.length; i++) {
      let dailyWorkId = record[i].dailyWorkId,
        workDate = record[i].workDate,
        forWork = record[i].forWork,
        forWorkType = record[i].forWorkType,
        toOrBy = record[i].toOrBy;
      if (record[i].workDetailsList) {
        for (let j = 0; j < record[i].workDetailsList.length; j++) {
          tempRecForExcel.push({
            date: workDate,
            company: record[i].workDetailsList[j].item,
            ContactPerson: record[i].workDetailsList[j].description,
            category: record[i].workDetailsList[j].category,
            quantity: record[i].workDetailsList[j].quantity,
            unitPrice: record[i].workDetailsList[j].unitPrice,
            amount: record[i].workDetailsList[j].amount,
            discount: record[i].workDetailsList[j].discount,
            discountPer: record[i].workDetailsList[j].discountPer,
            // quantity: record[i].workDetailsList[j].quantity,
            totalBalance: record[i].workDetailsList[j].totalBalance,
            remarks: record[i].workDetailsList[j].remarks,
            // amount: record[i].workDetailsList[j].amount,
          });
        }
      }
    }

    //     let grandTotal = 0;
    for (let i = 0; i < tempRecForExcel.length; i++) {
      if (!isNaN(parseFloat(tempRecForExcel[i].amount))) {
        grandTotal += parseFloat(tempRecForExcel[i].amount);
      }
    }

    tempRecForExcel.push({
      date: "",
      company: "",
      ContactPerson: "",
      category: "",
      quantity: "",
      unitPrice: "",
      amount: "",
      discount: "",
      discountPer: "TOTAL BALANCE",
      // quantity: record[i].workDetailsList[j].quantity,
      totalBalance: grandTotal.toFixed(2),
      remarks: "",
      // amount: record[i].workDetailsList[j].amount,
    });

    setexcelData(tempRecForExcel);

    console.log("tempRecord", tempRecord);
    setrowData(tempRecord);
  };

  //workDate
  //rowData.workDate
  const filterDataSearch = () => {
    const filteredData = rowData.filter((data) => {
      const workDate = new Date(data.workDate);
      const fromDateObj = new Date(fromDate);
      const toDateObj = new Date(toDate);

      return workDate >= fromDateObj && workDate <= toDateObj;
    });

    setrowData(filteredData);
  };

  const columnDefs = [
    { headerName: "Date ", field: "workDate" },
    { headerName: "Person Name", field: "description" },
    { headerName: "Company Name", field: "item" },
    // { headerName: "For", field: "forWork" },
    { headerName: "forWorkType", field: "forWorkType" },
    // { headerName: "Quantity", field: "quantity" },
    // { headerName: "Unit Price", field: "unitPrice" }, discountPer

    { headerName: "Amount", field: "amount" },
    { headerName: "Discount ", field: "discount" },
    { headerName: "Dis(%) ", field: "discountPer" },
    { headerName: "Total Balance", field: "totalBalance" },
    { headerName: "Remarks ", field: "remarks" },

    {
      headerName: "Actions",
      filter: false,
      field: "dailyWorkId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            View{" "}
          </Button>
        </div>
      ),
    },
  ];
  const actionButton = (params) => {
    console.log(params.data.dailyWorkId);
    navigate(`/create-new-work/${params.data.dailyWorkId}/${categoryId}`);
    // history.push(
    //   `/attraction/attraction-creation/${params.data.attractionsId}`
    // ); /
  };

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const [showModel, setshowModel] = useState(false);
  const [open, setOpen] = React.useState(false);

  return (
    <div>
      <Grid.Row>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            {categoryId != 0 && (
              <Button
                type="submit"
                primary
                onClick={() => navigate(`/create-new-work/null/${categoryId}`)}
              >
                Create New
              </Button>
            )}

            {excelData !== null && (
              <Button
                color="primary"
                onClick={(e) => exportToCSV(excelData, "Daily_Work_Report")}
              >
                Download CSV
              </Button>
            )}

            <Modal
              closeIcon
              open={open}
              trigger={<Button color="primary">Credit Money</Button>}
              onClose={() => setOpen(false)}
              onOpen={() => setOpen(true)}
            >
              <Header content="Credit Amount" />
              <Modal.Content>
                {/* <Grid.Row>
                <Grid columns="two">
                  <Grid.Row>
                    <Grid.Column>
                      <Field
                        name="paymentMode"
                        label="Work Category"
                        type="text"
                        component={renderTextField}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Field
                        name="openingBalance"
                        label="Opening Balance"
                        type="text"
                        component={renderTextField}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Row> */}
              </Modal.Content>
              <Modal.Actions>
                <Button color="red" onClick={() => setOpen(false)}>
                  <Icon name="remove" /> Cancel
                </Button>
                <Button color="green" onClick={() => setOpen(false)}>
                  <Icon name="checkmark" /> Save
                </Button>
              </Modal.Actions>
            </Modal>
          </div>

          <div
            style={{
              display: "flex",
            }}
          >
            <Form.Input
              name="from"
              label="from"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
            <Form.Input
              name="to"
              label="To"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
            <Button color="primary" onClick={(e) => getWorkList()}>
              Filter Search
            </Button>
          </div>
        </div>
      </Grid.Row>
      <Divider hidden /> <Divider />
      <div className="ag-theme-alpine" style={{ height: 600 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          pagination={true}
        ></AgGridReact>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {/* <div
            style={{
              display: "flex",
            }}
          >
            <Button color="primary" onClick={() => getFilteredData()}>
              {getFilter === false ? "GET TOTAL" : "GET FULL TOTAL"}
            </Button>
            <h2>
              Total :{" "}
              {getFilterTotal &&
                getFilterTotal[getFilterTotal.length - 1].amount.toFixed(2)}
            </h2>
          </div> */}
        <div>
          {" "}
          <h2>Total Amount: {grandTotalAmount.toFixed(2)}</h2> {}
          {/* {grandTotal.toFixed(2)} */}
        </div>
      </div>
    </div>
  );
};

export default reduxForm({
  form: "DailyWorkList",
})(DailyWorkList);
